import { forwardRef } from "react";
import { SnackbarContent } from "notistack";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import { Toaster } from "@src/components";
import type { ReportCompleteProps } from "./report-complete.types";

export const ReportComplete = forwardRef<HTMLDivElement, ReportCompleteProps>(
  ({ ...props }, ref) => {
    return (
      <SnackbarContent ref={ref}>
        <Card>
          <CardActions sx={{ padding: 0 }}>
            {props.message && <Toaster message={props.message} />}
          </CardActions>
        </Card>
      </SnackbarContent>
    );
  }
);

ReportComplete.displayName = "ReportComplete";

// export default ReportComplete;
